import styled from '@emotion/styled'

import { mediaQueryUp } from '~/utils/grid'

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  width: 100vw;
  max-width: 1320px;
  height: 8.375rem;

  ${mediaQueryUp('l')} {
    height: 12.5rem;
  }
`

export const BannerImages = styled.div`
  display: flex;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  width: 600px;
  left: calc((600px - 100vw) / -2);
  height: 8.375rem;

  ${mediaQueryUp('l')} {
    height: 12.5rem;
    justify-content: center;
    width: 1320px;
    left: calc((1320px - 100vw) / -2);
  }

  @media (min-width: 1320px) {
    width: 1320px;
    margin: 0 auto;
    left: 0;
  }
`

export const ImageLeft = styled.img`
  height: 8.5rem;
  width: 191px;
  transition: all 0.2s;

  ${mediaQueryUp('l')} {
    width: 485px;
    height: 340px;
    transform: translate(0, -8rem);
    transform-origin: right center;
  }
`

export const ImageCenter = styled.img`
  height: 89px;
  width: 176px;
  margin: 0 1rem 0 2rem;
  align-self: center;

  ${mediaQueryUp('l')} {
    margin: 0 4.5rem;
    width: 254px;
    height: 129px;
  }
`

export const ImageRight = styled.img`
  height: 114px;
  width: 158px;
  transition: all 0.2s;

  ${mediaQueryUp('l')} {
    width: 485px;
    height: 340px;
    padding: 1.5rem;
    transform: translate(0, -10rem) rotate(10deg);
    transform-origin: left center;
  }
`
